// https://vuex.vuejs.org/guide/getters.html
import serviceMenu from "./serviceMenu.js";

// export `getters` as a named export
const getters = {
  headers: state => {
    return state.menuData;
  },
  headersRawMenu: (state, getters, rootState) => {
    const permissions = true;
    const profileType = rootState.header.userProfile.profileType;
    const role = rootState.header.userProfile.roles;

    return serviceMenu(
      permissions,
      profileType,
      role,
      rootState.header.userProfile.additionalProfileInfo
    );
  }
};

export default getters;
